import { Tooltip } from "@mui/material";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { convertirFechaIsoAFormato } from "../../../../utilidades/formateos";
import { useExcelExport } from "../../../../utilidades/customHooks/useExcelExport";
import EditarModal from "./EditarModal";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { pagarServicio } from "../integracion";


const Tabla = ({ data, getBitacorasFunc }) => {

    const { exportarAExcel } = useExcelExport()
    const [visible, setVisible] = useState(false);
    const [rowDataId, setRowDataId] = useState(null);


    // funciones para descargar exel
    const descargaExelTH = () => {

        const columnas = [
            { field: 'BITACORA', header: 'BITACORA' },
            { field: 'FECHA', header: 'FECHA' },
            { field: 'CONFIRMADA', header: 'CONFIRMADA' },
            { field: 'TRANSFERIDO', header: 'TRANSFERIDO' },
            { field: 'RUTA', header: 'RUTA' },
            { field: 'DESCRIPCION', header: 'DESCRIPCION' },
            { field: 'OPERADOR', header: 'OPERADOR' },
            { field: 'RUTA', header: 'RUTA' },
            { field: 'TIPO', header: 'TIPO' },
            { field: 'PAGO_CHOFER', header: 'PAGO_CHOFER' },

        ]
        const datosProcesados = data.map((fila) => {
            const nuevaFila = {};
            columnas.forEach(({ field, header }) => {
                let valor = fila[field];

                // Formatear si el campo es una fecha
                if (field.toLowerCase().includes('fecha') && typeof valor === 'string') {
                    try {
                        valor = convertirFechaIsoAFormato(valor);
                    } catch { }
                }
                if (field.toLowerCase().includes('confirmada')) {
                    try {
                        if (valor == true) { valor = 'Si'; }
                        else if (valor == false) { valor = 'No' }
                    } catch { }
                }
                if (field.toLowerCase().includes('transferido')) {
                    try {
                        if (valor == true) { valor = 'Si'; }
                        else if (valor == false) { valor = 'No' }
                    } catch { }
                }

                nuevaFila[header] = valor !== undefined ? valor : '';
            });
            return nuevaFila;
        });
        exportarAExcel(datosProcesados, columnas, "REPORTE_BITACORA_TH")
    }
    const descargaExelGPS = () => {

        const columnas = [
            { field: 'BITACORA', header: 'BITACORA' },
            { field: 'FECHA', header: 'FECHA' },
            { field: 'FOLIO_SERVICIO', header: 'FOLIO_SERVICIO' },
            { field: 'OPERADOR', header: 'OPERADOR' },
            { field: 'RUTA', header: 'RUTA' },
            { field: 'ID_UNIDAD', header: 'ID_UNIDAD' },
            { field: 'DESCRIPCION', header: 'DESCRIPCION' },
            { field: 'KM_INICIAL', header: 'KM_INICIAL' },
            { field: 'KM_FINAL', header: 'KM_FINAL' },

        ]
        const datosProcesados = data.map((fila) => {
            const nuevaFila = {};
            columnas.forEach(({ field, header }) => {
                let valor = fila[field];

                // Formatear si el campo es una fecha
                if (field.toLowerCase().includes('fecha') && typeof valor === 'string') {
                    try {
                        valor = convertirFechaIsoAFormato(valor);
                    } catch { }
                }
                nuevaFila[header] = valor !== undefined ? valor : '';
            });
            return nuevaFila;
        });
        exportarAExcel(datosProcesados, columnas, "REPORTE_BITACORA_GPS")
    }
    // funciones de integracion 
    const pagar = async (rowData) => {
        if (rowData.TERMINADO == true) {
            await pagarServicio(rowData.BITACORA)
            await getBitacorasFunc()
        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'Esta bitacora no esta terminada', // Título de la alerta
            });
        }

    }

    // templates para las tablas

    const renderCheck = (value) => (
        <i
            className={`pi ${value ? 'pi-check text-green-500' : 'pi-times text-red-500'}`}
        />
    );

    const renderActions = (rowData) => (
        <div className="bitacoras-acciones">
            <Tooltip title='Editar'>
                <Button icon="pi pi-pencil" rounded text severity="info" onClick={() => { setVisible(true); setRowDataId(rowData) }} />
            </Tooltip>
            {
                rowData.PAGAR ?
                    <Tooltip title={`${rowData.CANCELADO? 'Cancelado' : 'Pagar'}`}>
                        <Button disabled={rowData.CANCELADO?true:false} icon="pi pi-dollar" rounded text severity="success" onClick={() => pagar(rowData)} />
                    </Tooltip>
                    :
                    <Tooltip title={`${rowData.CANCELADO? 'Cancelado' : 'Listo para pagar'}`}>
                        <Button disabled={rowData.CANCELADO?true:false} icon="pi pi-dollar" rounded text severity="danger" onClick={() => pagar(rowData)} />
                    </Tooltip>

            }
        </div>
    );
    return (
        <>
            <div className="bitacoras-botones">
                <Tooltip title='Descargar reporte en formato Exel para TH'>
                    <Button label="Reporte Bitácora TH" icon="pi pi-file" onClick={descargaExelTH} />
                </Tooltip>
                <Tooltip title='Descargar reporte en formato Exel para GPS'>
                    <Button label="Reporte Bitacora GPS" icon="pi pi-globe" severity="secondary" onClick={descargaExelGPS} />
                </Tooltip>
            </div>

            {/* Tabla */}
            <div className="mt-4">
                <DataTable
                    value={data}
                    stripedRows
                    scrollable
                    scrollHeight="calc(100vh - 290px)"
                    virtualScrollerOptions={{
                        itemSize: 46, // Ajusta al tamaño aproximado de tus filas
                    }}
                    // paginator
                    // rows={10}
                // rowsPerPageOptions={[5, 10, 20, 50]}
                // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                // currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                >
                    <Column field="BITACORA" header="BITACORA" />
                    <Column field="FOLIO_SERVICIO" header="Folio" />
                    <Column field="FECHA" header="Fecha" body={(rowData) => convertirFechaIsoAFormato(rowData.FECHA)} />
                    <Column field="OPERADOR" header="Operador" />
                    <Column field="RUTA" header="Ruta" />
                    <Column field="ID_UNIDAD" header="Unidad" />
                    <Column field="DESCRIPCION" header="Tipo Unidad" />
                    <Column field="KM_INICIAL" header="KM Inicial" />
                    <Column field="KM_FINAL" header="KM Final" />
                    <Column field="CONFIRMADA" header="C" body={(rowData) => renderCheck(rowData.CONFIRMADA)} />
                    <Column field="TERMINADO" header="T" body={(rowData) => renderCheck(rowData.TERMINADO)} />
                    <Column header="Acciones" body={renderActions} style={{ textAlign: "center", width: "10rem" }} />
                </DataTable>
            </div>
            <EditarModal setVisible={setVisible} visible={visible} data={rowDataId} setRowDataId={setRowDataId} getBitacorasFunc={getBitacorasFunc}></EditarModal>
        </>
    )
}
export default Tabla